import React from 'react';
import { motion } from 'framer-motion';
export function BotanicalDivider() {
  return <motion.div initial={{
    opacity: 0,
    scale: 0.9
  }} whileInView={{
    opacity: 1,
    scale: 1
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.8,
    ease: 'easeOut'
  }} className="flex justify-center py-16 opacity-60" aria-hidden="true" data-id="element-16">
      <svg width="120" height="40" viewBox="0 0 120 40" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-sage" data-id="element-17">
        <path d="M10 20C30 20 40 10 60 10C80 10 90 20 110 20" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" data-id="element-18" />
        <path d="M35 15C35 15 30 5 25 10C20 15 30 20 35 15Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-19" />
        <path d="M85 25C85 25 90 35 95 30C100 25 90 20 85 25Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-20" />
        <path d="M60 10C60 10 55 -2.38419e-07 50 5C45 10 55 15 60 10Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-21" />
        <path d="M60 10C60 10 65 20 70 15C75 10 65 5 60 10Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-22" />
      </svg>
    </motion.div>;
}